'use client';

import { Button } from '@petsmart-ui/sparky';

import type { FrequencyRecommendation } from '../model/frequencyRecommendation';
import { getSetFrequencyButtonLabel, mapRecommendedFrequencyToAutoship } from '../model/mapRecommendedFrequency';

type FooterProps = {
    calculationResult: FrequencyRecommendation | null;
    isCalculateDisabled: boolean;
    canReset: boolean;
    onCalculate: () => void;
    onApplySuggestedFrequency: () => void;
    onReset: () => void;
    onResetStart: () => void;
};

export const Footer = ({
    calculationResult,
    isCalculateDisabled,
    canReset,
    onCalculate,
    onApplySuggestedFrequency,
    onReset,
    onResetStart,
}: FooterProps) => {
    const mappedFrequency = calculationResult ? mapRecommendedFrequencyToAutoship(calculationResult) : null;

    return (
        <div className="frequency-calculator-drawer__actions">
            {mappedFrequency ? (
                <Button
                    fullWidth
                    type="button"
                    variant="primary"
                    text={getSetFrequencyButtonLabel(mappedFrequency)}
                    onClick={onApplySuggestedFrequency}
                    data-testid="frequency-calculator-apply"
                />
            ) : (
                <Button
                    fullWidth
                    type="button"
                    variant="primary"
                    text="Calculate"
                    disabled={isCalculateDisabled}
                    onClick={onCalculate}
                    data-testid="frequency-calculator-submit"
                />
            )}
            {canReset && (
                <Button
                    fullWidth
                    type="button"
                    variant="link"
                    text="Reset"
                    onMouseDown={onResetStart}
                    onClick={onReset}
                    data-testid="frequency-calculator-reset"
                />
            )}
        </div>
    );
};
